"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _PDFErrorComponent = require("./PDFErrorComponent.styled");
/**
 * A component use to render a custom error message when the PDF fails to load
 * @returns {React.ReactElement}
 */
var PDFErrorComponent = function PDFErrorComponent(props) {
  var size = props.size;
  return /*#__PURE__*/_react["default"].createElement(_PDFErrorComponent.PDFErrorIcon, {
    size: size
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faFilePdf
  }));
};

/**
 * Default props for the PDFErrorComponent component.
 * @type {Object}
 * @property {string} size - The size of the error icon. Default is 'medium'.
 */
PDFErrorComponent.defaultProps = {
  size: 'medium'
};

/**
 * Prop types for the PDFErrorComponent component.
 * @type {Object}
 * @property {string} size - The size of the error icon.
 */
PDFErrorComponent.propTypes = {
  size: _propTypes["default"].oneOf(['small', 'medium', 'large'])
};
var _default = exports["default"] = PDFErrorComponent;